export const INITIAL_CHIP_COUNT = 3;

export const useShowCount = (total: number) => {
  return total - INITIAL_CHIP_COUNT === 1 ? INITIAL_CHIP_COUNT + 1 : INITIAL_CHIP_COUNT;
};
